import { useEffect } from 'react';
import { useDataFormPage } from '../../providers/DataFormPageProvider';
import { DataFormPage } from './DataFormPage';
import { Box, useTheme } from '@mui/joy';
import { motion } from 'framer-motion';
import megaphone from '../../assets/megaphone.png';
import moneyStack from '../../assets/money_stack.png';
import ControlPanelLayout from '../Controls/ControlPanelLayout';
import { useRoute } from '../../providers/RouteProvider';
import { useMediaQuery } from '../../hooks';
import { DONOR_FLAGS } from '../../lib/const';

interface DonorPageProps {}

export const DonorPage: React.FC<DonorPageProps> = () => {
	const theme = useTheme();
	const { page, setPage } = useDataFormPage();
	const { donorPage, setDonorPage } = useRoute();

	const matchesMd = useMediaQuery(theme.breakpoints.up('md'));
	const matchesSm = useMediaQuery(theme.breakpoints.up('sm'));

	useEffect(() => {
		setPage(donorPage === 'state' ? 'donorState' : 'donorNational');
		if (!donorPage) {
			setDonorPage(DONOR_FLAGS.nationalDisabled ? 'state' : 'national');
		}
		if (DONOR_FLAGS.nationalDisabled) {
			setDonorPage('state');
		}
	}, [donorPage, setDonorPage, setPage]);

	return (
		<DataFormPage
			chapter='donors'
			chapterHighlightViz={
				<Box
					sx={{
						height: '100%'
					}}
				>
					<ControlPanelLayout
						page={page ?? 'donorState'}
						selectOnly
						selectSx={{
							backgroundColor: '#FFFFFF',
							margin: 0,
							padding: 0,
							marginBottom: '44px'
						}}
					/>

					<Box
						sx={{
							marginY: '35px',
							marginX: 'auto',
							position: 'relative',
							width: { xs: '250px', sm: '350px', md: '452.11px' },
							display: 'block',
							height: { xs: '200px', sm: '300px', md: '365px' }
						}}
					>
						<Box
							sx={{
								marginX: 'auto',
								borderRadius: 6,
								position: 'absolute',
								bottom: 0,
								height: 12,
								width: { xs: '200px', sm: '300px', md: '389px' },
								background: theme.palette.chaptersDonors.solidBg
							}}
						/>
						<motion.div
							animate={{ y: 0, opacity: 1, scaleX: 1 }}
							initial={{ y: 600, opacity: 0, scaleX: 1 }}
							transition={{ delay: 1, type: 'spring', duration: 1, bounce: 0 }}
							style={{
								position: 'relative',
								height: '100%'
							}}
						>
							<img
								src={megaphone}
								width={'57%'}
								style={{
									transform: 'scaleX(-1)',
									left: '35%',
									bottom: matchesMd ? '20%' : matchesSm ? '18%' : '22%',
									position: 'absolute',
									width: '57%'
								}}
								alt='Hand holding megaphone'
							/>
							<img
								src={moneyStack}
								width={'38%'}
								style={{
									left: '24%',
									top: matchesMd ? '70%' : matchesSm ? '71%' : '68%',
									position: 'absolute',
									width: '38%'
								}}
								alt='stack of money'
							/>
						</motion.div>
					</Box>
				</Box>
			}
		/>
	);
};
